'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$$anon$27() {
}
export { $c_Lapp_data_AppDocumentDataForm$$anon$27 as $c_Lapp_data_AppDocumentDataForm$$anon$27 };
$p = $c_Lapp_data_AppDocumentDataForm$$anon$27.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$$anon$27;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$$anon$27() {
}
export { $h_Lapp_data_AppDocumentDataForm$$anon$27 as $h_Lapp_data_AppDocumentDataForm$$anon$27 };
$h_Lapp_data_AppDocumentDataForm$$anon$27.prototype = $p;
$p.a9 = (function(x) {
  return false;
});
$p.a8 = (function(x, default$1) {
  return (false ? x.Z() : default$1.h(x));
});
var $d_Lapp_data_AppDocumentDataForm$$anon$27 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$$anon$27, "app.data.AppDocumentDataForm$$anon$27", ({
  B1: 1,
  h: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$$anon$27 as $d_Lapp_data_AppDocumentDataForm$$anon$27 };
//# sourceMappingURL=app.data.-App-Document-Data-Form$$anon$27.js.map
